import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Card, Skeleton, Row, Col, Table, Button, Checkbox, List } from 'antd';
import { _OpenDoc } from './_OpenDoc';
import { CheckCircleTwoTone, FilePdfOutlined, FileTextOutlined } from '@ant-design/icons';
import moment from 'moment';
import { isMobile } from '../../../../shared/custom-ant-d'
import { AESDecrypt } from '../../../../shared/Crypto';
import { reqGetListOnboarding, reqGetSaveOnboardingDocumentESignatureAgreement } from '../../../../axios/api';

const Documents = (props) => {
  const {
    formData,
    onboardingDocumentList, setOnboardingDocumentList,
    setShowButtons, setShowW4Form
  } = props;
  const Auth = useSelector(state => state.Auth);
  const [pageLoading, setPageLoading] = useState(false);
  const [onboardingDoc, setOnboardingDoc] = useState(null);
  const [signedDocs, setSignedDocs] = useState(null);
  const [isSigned, setIsSigned] = useState(false);
  const [signature, setSignature] = useState(null);
  const [isAgreed, setIsAgreed] = useState(false);
  const [showAgreement, setShowAgreement] = useState(true);
  const docProps = {
    onboardingDocumentList, setOnboardingDocumentList,
    onboardingDoc, setOnboardingDoc,
    signedDocs, setSignedDocs, setPageLoading,
    setShowButtons, isSigned, setIsSigned,
    signature, setSignature, Auth
  }

  const columns = [
    {
      title: 'Document',
      dataIndex: 'documentFriendlyName',
      key: 'documentFriendlyName',
      width: '50%',
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => {
            if (record.DocumentType == 'DOC') {
              setOnboardingDoc(record);
              setIsSigned(record.SignatureDt !== null)
              //setIsSigned(false)
            }
            else {
              setShowW4Form(true);
            }
          }}
        >
          {
            (record.DocumentType == 'DOC') ?
              (<FilePdfOutlined className="inline-icon" />) :
              (<FileTextOutlined className="inline-icon" />)
          }
          {record.DocumentFriendlyName}
        </Button>
      ),
    },
    {
      title: 'Signed',
      dataIndex: 'isSigned',
      key: 'isSigned',
      align: 'center',
      render: (text, record) => (
        (record.SignatureDt !== null) ?
          (<CheckCircleTwoTone className="inline-icon" twoToneColor="#52c41a" />) : (<></>)
      ),
    },
    {
      title: 'Date Signed',
      dataIndex: 'Date',
      key: 'isSigned',
      align: 'center',
      render: (text, record) => (
        (record.SignatureDt !== null) ?
          (moment(record.SignatureDt).format('MM/DD/YYYY')) : (<></>)
      ),
    },
  ];

  useEffect(() => {
    if (formData != null) {
      if (formData.DocumentsElectronicSignatureAgreementDt == null) {
        setShowAgreement(true);
      }
      else {
        setShowAgreement(false);
      }
    }
  }, [formData]);

  useEffect(() => {
    if (onboardingDocumentList == null) {
      setPageLoading(true);
      reqGetListOnboarding(Auth.candidateID)
        .then(res => {
          if (res.data.isSuccess) {
            var data = JSON.parse(AESDecrypt(res.data.onboardingListEncJSON));
            if (data.length > 0) {
              setOnboardingDocumentList(data[0].OnboardingDocumentList);
            }
          }
          setPageLoading(false);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [onboardingDocumentList]);

  const onAgree = (isAgreed) => {
    if (isAgreed) {
      var payloadStr = JSON.stringify({ OnboardingID: formData.OnboardingID });
      reqGetSaveOnboardingDocumentESignatureAgreement(payloadStr)
        .then(res => {
          if (res.data.isSuccess) {
            setShowAgreement(false);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  const Agreement = () => {
    return (
      <>
        <Row justify='center'>
          <Col md={22}>
            <b>Electronic Signature Step for {`${Auth.firstName} ${Auth.lastName}`}</b>
            <p>Welcome to the electronic signature step. At this step you will sign all of your paperwork.
              Please acknowledge your agreement to use electronic signature technology by clicking the agreement below.
            </p><br />
            <b>Agreement to Use Electronic Click Signature to Sign Documents</b><br />
            <Checkbox onChange={(e) => {
              setIsAgreed(true);

            }} checked={isAgreed}>
              I, {`${Auth.firstName} ${Auth.lastName}`}, agree to sign these electronic PDF documents electronically, either by drawing or typing my electronic signature.  I understand that a record of each document and my signing of it will be stored in electronic code.  I intend both the signature I inscribe with the drawing or typing technology as well as the electronic record of it to be my legal signature to the document and have the same force and effect as my manual signature. I confirm that the document is "written" or "in writing" and that any accurate record of the document is an original of the document.
            </Checkbox>
          </Col>
        </Row><br />
        <Row>
          <Col md={{ span: 24, offset: 11 }}>
            <Button type="danger" disabled={!isAgreed}
              onClick={() => {
                onAgree(true);
              }}>
              Continue
            </Button>
          </Col>
        </Row>
      </>
    );
  }

  const Instruction = () => {
    return (
      <>
        <Card type="inner">
          <p>Click on the links for each Document listed below. Once each document is completed, and signed you will see a Green Check Mark, next to the Document. After all documents have been marked completed, this will conclude your Pre-Onboarding activities, and a Recruiter will reach out to you to discuss next steps.</p>
        </Card>
        <br />
      </>
    )
  }

  return (
    <>
      <Card type="inner">
        {
          (pageLoading) ? (<Skeleton active />) : (<></>)
        }
        {
          (onboardingDoc == null && !pageLoading && onboardingDocumentList != null) ?
            (
              <>
                {
                  (showAgreement) ? (<Agreement />) :
                    (<>
                      {
                        (isMobile) ?
                          (
                            <>
                              <Instruction />
                              <List
                                size="small"
                                header={<div style={{ textAlign: 'center', fontWeight: '700' }} >Document</div>}
                                // footer={<div>Footer</div>}
                                bordered
                                dataSource={onboardingDocumentList}
                                renderItem={item => (
                                  <List.Item
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      if (item.DocumentType == 'DOC') {
                                        setOnboardingDoc(item);
                                        setIsSigned(item.SignatureDt !== null)
                                        //setIsSigned(false)
                                      }
                                      else {
                                        setShowW4Form(true);
                                      }
                                    }}>
                                    <List.Item.Meta
                                      avatar={
                                        (item.DocumentType == 'DOC') ?
                                          (<FilePdfOutlined className="inline-icon" />) :
                                          (<FileTextOutlined className="inline-icon" />)
                                      }
                                      title={
                                        <div>
                                          {item.DocumentFriendlyName}
                                          {
                                            (item.SignatureDt !== null) ?
                                              (
                                                <>&nbsp;&nbsp;&nbsp;&nbsp;
                                                  <CheckCircleTwoTone className="inline-icon" twoToneColor="#52c41a" />
                                                </>
                                              ) : (<></>)
                                          }
                                        </div>
                                      }
                                      description={(item.SignatureDt !== null) ? `Date Signed: ${moment(item.SignatureDt).format('MM/DD/YYYY')}` : ''}
                                    />
                                  </List.Item>
                                )}
                              />
                            </>
                          ) :
                          (
                            <Row justify='center'>
                              <Col md={22}>
                                <Instruction />
                                <Table
                                  columns={columns}
                                  dataSource={onboardingDocumentList}
                                  pagination={false}
                                  rowKey={record => record.DocumentID} />
                              </Col>
                            </Row>
                          )
                      }
                    </>)
                }

              </>
            ) : (<_OpenDoc {...docProps} />)
        }
      </Card>
    </>
  )
}
export default Documents
